/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workflow_Input_PortInputs */

const cs_workflow_input_port = /** @type {(inputs: Workflow_Input_PortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vstupní port`)
};

const en_workflow_input_port = /** @type {(inputs: Workflow_Input_PortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Input port`)
};

/**
* | output |
* | --- |
* | "Input port" |
*
* @param {Workflow_Input_PortInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const workflow_input_port = /** @type {((inputs?: Workflow_Input_PortInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workflow_Input_PortInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_workflow_input_port(inputs)
	return cs_workflow_input_port(inputs)
});